import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../../i18n';

/**
 * @summary ConfirmLoginChangeModal
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('confirm-login-change-modal')
class ConfirmLoginChangeModal extends i18nMixin(AoflElement) {
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'confirm-login-change-modal';

  @property({type: Function, property: true})
  resolve = null;

  connectedCallback() {
    super.connectedCallback();
  }

  close() {
    this.resolve(false);
  }

  firstUpdated(changedProperties) {
    this.shadowRoot.querySelector('[tabindex="0"]').focus();
  }


  saveChanges() {
    this.resolve(true);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default ConfirmLoginChangeModal;
